/**
 * @generated SignedSource<<2e7e37cc9c0e9ea296c69532b65419cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupInviteDialog_group$data = {
  readonly id: string;
  readonly " $fragmentType": "GroupInviteDialog_group";
};
export type GroupInviteDialog_group$key = {
  readonly " $data"?: GroupInviteDialog_group$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupInviteDialog_group">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupInviteDialog_group",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Group",
  "abstractKey": null
};

(node as any).hash = "57945f7cd42c673d0dc779149dddccb6";

export default node;
